import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService, AppContext } from './../shared';
import tippy from 'tippy.js'

@Component({
  selector: 'my-home',
  template: require('./home.component.html'),
  styles: [require('./home.component.scss')],
})

export class HomeComponent implements OnInit {
  constructor(private route: ActivatedRoute, private seo: SeoService, private app: AppContext) {
    // Do stuff
  }

  title = 'Linescape - Ocean Container Shipping Schedules';
  description = 'Linescape is the first independent liner shipping search engine for ocean container sailing schedules with searches filtered by port, vessel or carrier.';

  ngOnInit() {
    this.seo.set(this.title, this.description);

    tippy('.tippy-hover', {
      arrow: true,
      size: 'small'
      // content: 'Tooltip',
    })
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/home/home.component.ts